/* StorageOZ topic signup receipt. No email collection by JS, no fetch, no popup/timer changes. */
(() => {
  const start = () => document.querySelectorAll('[data-soz-topic-newsletter]').forEach(root => {
    if (root.dataset.sozBound === 'true') return;
    root.dataset.sozBound = 'true';
    const form = root.querySelector('form.soz-topic-newsletter__form');
    if (!form) return;
    const topic = root.dataset.topic === 'drawer' ? 'drawer' : 'fridge';
    const source = 'inline_' + topic;
    const key = 'soz_topic_newsletter_pending_v1:' + form.id;
    const emit = (name, details = {}) => window.SOZNewsletter?.track?.(name, { source, ...details });
    const now = Date.now();
    let pending = null;
    try { pending = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) {}
    const validPending = pending && pending.form === form.id && Number.isFinite(pending.at) && pending.at <= now && now - pending.at < 30 * 60 * 1000;
    const serverSuccess = !!form.querySelector('[data-soz-topic-server-success]');
    const serverError = !!form.querySelector('[data-soz-topic-server-error]');
    if (serverSuccess && validPending) {
      try { sessionStorage.removeItem(key); } catch (_) {}
      const fields = form.querySelector('[data-soz-topic-fields]');
      const receipt = form.querySelector('[data-soz-topic-success]');
      if (fields) fields.hidden = true;
      if (receipt) { receipt.hidden = false; receipt.focus({ preventScroll: true }); }
      window.SOZNewsletter?.markSuccessful?.();
      emit('form_success', { result: 'server_accepted' });
    } else if (serverError && validPending) {
      try { sessionStorage.removeItem(key); } catch (_) {}
      emit('form_error', { reason: 'server' });
    }
    if ('IntersectionObserver' in window) {
      let inView = false;
      new IntersectionObserver(entries => { inView = entries.some(e => e.isIntersecting); if (inView) emit('form_view'); }, { threshold: 0.5 }).observe(form);
      document.addEventListener('visitorConsentCollected', () => { if (inView) emit('form_view'); });
    }
    let submitting = false, invalidSent = false;
    form.addEventListener('invalid', () => { if (!invalidSent) { invalidSent = true; emit('form_error', { reason: 'validation' }); } }, true);
    form.addEventListener('submit', event => {
      if (submitting) { event.preventDefault(); return; }
      submitting = true;
      try { sessionStorage.setItem(key, JSON.stringify({ form: form.id, at: Date.now() })); } catch (_) {}
      emit('submit');
    });
    window.addEventListener('pageshow', () => { submitting = false; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
